import { CALENDAR_SALE } from './../../../routes';
import { useNavigate } from "react-router";
import {
  ACCEPT_TRANSACTION_URL,
  CLEAR_BASKET_URL,
  GET_BASKET_BY_ECARD,
  REMOVE_ITEM_BASKET_URL,
  SAVE_BY_ECARD,
  SAVE_RESERVATION_V2,
} from "../../../api/apiRoutes";
import { setSuccessMessage } from "../../../store/alerts/alertsActions";
import { useDispatch, useSelector } from "react-redux";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { SALE_MOVIE_PAGE } from "../../../routes";
import { updateSelectedSeats } from "../../../store/basket/basketActions";
import { State } from "../../../store";
import { setSaveData } from "../../../models/SaveData";
import { InputsFinalize } from "../../../models/InputsFinalize";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import { get } from "../../../api";
import { useState } from "react";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { useTranslation } from "react-i18next";
// import { InputsFinalize } from "../FinalizeNoLogin";

export default function useFinalizeManager() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const selectedSeats = useSelector((state: State) => state.basket.selectedSeats);
  const userData = useSelector((state: State) => state.auth.userData);
  const [alert, setAlert] = useState<string>("");
  const [loader, setloader] = useState<boolean>(false);
  const [paymentUrl, setPaymentUrl] = useState<string>("");
  const { forceGoToPayment } = useParentMessage();

  const { handleGetBasket } = useBasketManager();
  // const startPageUrl = useSelector((state: State) => state.config.configuration.startPageUrl);
  const homePage = sessionStorage.getItem("HomePage");

  const handleBackButton = () => {
    navigate(-1);
  };

  const handleClearBasket = async (showAlert = true) => {
    const { isError } = await post(CLEAR_BASKET_URL(facilityIds));
    if (!isError) {
      dispatch(updateSelectedSeats([]));
      if (showAlert) {
        dispatch(setSuccessMessage(t("wyczyszczono_koszyk")));
      }
    }
  };
  const onRemoveItemFromBasket = async (idx: number) => {
    const { isError } = await post(REMOVE_ITEM_BASKET_URL, { idx });
    if (!isError) {
      dispatch(updateSelectedSeats(selectedSeats.filter((item, index) => index !== idx)));
      handleGetBasket();
    }
  };

  const acceptTransaction = async (data: InputsFinalize) => {
    setloader(true);
    const { result, isError, errorTable } = await post(ACCEPT_TRANSACTION_URL(setSaveData(data)));
    if (!isError) {
      dispatch(updateSelectedSeats([]));
      setPaymentUrl(result.PaymentURL);
      setloader(false);
      forceGoToPayment(result.PaymentURL);
      setTimeout(() => {
        if (result.PaymentURL.length < 4) {
          handleClearBasket();
          dispatch(setSuccessMessage(t("platnosc_przebiegla_pomyslnie")));
          {
            homePage ? navigate(homePage) : window.location.reload();
          }
        }
      }, 1500);

      // window.location.href = result.PaymentURL;
    }
    if (isError) {
      setAlert(errorTable[0]);
      setloader(false);
    }
  };

  // const saveReservation = async (data: InputsFinalize) => {
  //   setloader(true);
  //   const { result, isError, errorTable } = await post(ACCEPT_TRANSACTION_URL(setSaveData(data)));
  //   if (!isError) {
  //     dispatch(updateSelectedSeats([]));
  //     setPaymentUrl(result.PaymentURL);
  //     setloader(false);
  //     forceGoToPayment(result.PaymentURL);
  //     // window.location.href = result.PaymentURL;
  //   }
  //   if (isError) {
  //     setAlert(errorTable[0]);
  //     setloader(false);
  //   }
  // };

  const saveReservation = async (data: InputsFinalize) => {
    setloader(true);
    const { result, isError, errorTable } = await post(SAVE_RESERVATION_V2, setSaveData(data));
    if (!isError) {
      dispatch(updateSelectedSeats([]));
      setPaymentUrl(result.PaymentURL);
      setloader(false);
      forceGoToPayment(result.PaymentURL);
      // window.location.href = result.PaymentURL;
    }
    if (isError) {
      setAlert(errorTable[0]);
      setloader(false);
    }
  };

  // https://api.eaktywni.pl/tt-admin/EAktywni/basket/calculate/eCard?facilityIds=0,1218
  const calculateEcard = async () => {
    const { result, isError } = await get(GET_BASKET_BY_ECARD(facilityIds));
    if (!isError) {
      handleGetBasket();
    }
  };

  const eCardPaymnet = async () => {
    const { result, isError, errorTable } = await post(SAVE_BY_ECARD());
    if (!isError) {
      handleClearBasket();
      dispatch(setSuccessMessage(t("platnosc_ekarta_przebiegla_pomyslnie")));
      setTimeout(() => {
        // Przenosze do kalendarza
        navigate(CALENDAR_SALE);
      }, 500);
    } else {
      setAlert(errorTable[0]);
    }
  };

  return {
    loader,
    paymentUrl,
    alert,
    eCardPaymnet,
    calculateEcard,
    handleBackButton,
    handleClearBasket,
    onRemoveItemFromBasket,
    acceptTransaction,
    saveReservation,
  };
}
